
    export default {
        name: 'FreeProductHero',
        props: {
            link: {
                type: String,
                default: '',
            },
            margin: {
                type: String,
                default: '-mt-[45px]',
            },
            padding: {
                type: String,
                default: 'pb-0',
            },
            home: {
                type: String,
                default: 'false',
            },
            // Show a CTA button overlaid on the banner
            button: {
                type: String,
                default: 'false',
            },
            // Label for the button
            buttonText: {
                type: String,
                default: 'Shop Now',
            },
        },
        methods: {
            handleClick() {
                if (!this.link) return
                if (this.link.startsWith('http')) {
                    window.open(this.link, '_blank')
                } else {
                    this.$router.push(this.link)
                }
            },
        },
    }
